import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const attachmentApi = createApi({
  reducerPath: 'attachmentApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/attachments' }),
  tagTypes: ['Attachments'],
  endpoints: (builder) => ({
    getAttachments: builder.query({
      query: (searchParams = '') => searchParams,
      providesTags: ['Attachments']
    }),
    updateAttachment: builder.mutation({
      query: ({ id = '', ...data }) => ({
        url: `${id}`,
        method: 'PATCH',
        body: { attachment: data }
      }),
      invalidatesTags: ['Attachments']
    }),

    createAttachment: builder.mutation({
      query: (data) => ({
        method: 'POST',
        body: { attachment: data }
      }),
      invalidatesTags: ['Attachments']
    }),

    getAttachment: builder.query({
      query: (id) => ({ url: `/${id}` })
    })
  })
})

export const {
  useUpdateAttachmentMutation,
  useGetAttachmentQuery,
  useGetAttachmentsQuery,
  useCreateAttachmentMutation
} = attachmentApi
